module.exports = __webpack_public_path__ + "img/woman.968fd4d6.png";